import { Injectable } from '@angular/core'; 
import { AppConfig } from "Classes/AppConfig";

@Injectable() 
export class ConfigService { 

    constructor(
        private appConfig: AppConfig
    ) { }

    //callback

    public get getAdalConfig(): any
    {
        let val = true;//!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        let adalConfig = {
            tenant: this.appConfig.azureTenant,
            clientId: this.appConfig.azureClientId,
            redirectUri: process.env.PORTAL_URL,
            postLogoutRedirectUri: process.env.PORTAL_URL,// + "?LogOff=true",
            popUp: val,
            //isAngular: true
        };

        return adalConfig;
    }
} 


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./App/Services/config.service.ts